import axios from 'axios'
import config from '../config/config.ts'

const instance = axios.create({
  baseURL: config.get('apiBase'),
})

export default instance
